import { Item } from "@/types";

export const itemsSort = (a: Item, b: Item) => {
  if (a.is_folder && !b.is_folder) return -1;
  if (!a.is_folder && b.is_folder) return 1;
  if (a.inserted_at > b.inserted_at) return 1;
  if (a.inserted_at < b.inserted_at) return -1;
  return 0;
};
